import { CreditLineProvider, CreditLineResultStatus, EnumSchema, FromSchema, PolicyType } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export const BusinessCreditLineSchema = z.object({
    status: EnumSchema(CreditLineResultStatus).nullish(),
    provider: EnumSchema(CreditLineProvider).nullish(),
    creditLimit: z.number().nullish(),
    requestedAmount: z.number().nullish(),
    decisionType: EnumSchema(PolicyType).optional(),
    currency: EnumSchema(Currency).nullish(),
});

export class BusinessCreditLine extends FromSchema(BusinessCreditLineSchema) {
    status?: CreditLineResultStatus;
    provider?: CreditLineProvider;
    creditLimit?: number;
    requestedAmount?: number;
    decisionType?: PolicyType;
    currency?: Currency;
}
